/* eslint-disable */
require( 'es6-shim' );
import {CrossStorageClient} from 'cross-storage';

const CUSTOM_WIDGETS = {
  'DAA': `<div class="js-socialembed daa daa-widget-disclaimer">
	<div class="inquiry-widget-headline-placeholder">
	  <div class="widget-headline">
		  <div class="cwhite txt-center p15 hyphens">Wärmepumpe: Installationsbetrieb in Ihrer Nähe finden</div>
	  </div>
	  <div class="widget-advantages p20 fs13">
		<div class="widget-advantages-advantage"><i class="fa fa-check"></i> Angebote aus Ihrer Umgebung</div>
		<div class="widget-advantages-advantage"><i class="fa fa-check"></i> Regional aktive Fachbetriebe</div>
		<div class="widget-advantages-advantage"><i class="fa fa-check"></i> Kostenlos &amp; unverbindlich</div>
	  </div>
	</div>
	<div>
	  <div class="js-sme-privacydisclaimer js-sme-blocked">
		<div class="js-sme-form-button fs16">
		  <input class="checkbox js-sme-consent-button" type="checkbox" id="extcontent_{{configId}}" value="DAA" name="input-form_{{configId}}">
		  <label for="extcontent_{{configId}}">
			<span class="fs16"><strong>
			  Ja zeige mir Inhalte von Heizungsfinder (DAA GmbH) an. Ich kann das jederzeit widerrufen.
			</strong></span>
		  </label>
		</div>
		<span class="copy-txt fullwidth fs15">
		  Mehr dazu in der <a href="https://utopia.de/datenschutz/#DAA-Widget" class="disclaimer-first" title="Informationen zum Datenschutz" target="_blank">Utopia Datenschutzerklärung.</a>
		</span>
	  </div>
	</div>
  </div>
  `
};

const DETAIL_NAMES = {
  'DAA': 'Heizungsfinder (DAA GmbH)',
  'Internal': 'Interne Verlinkung'
};

export default class {
  constructor( $self, services ) {
    this.element = $self;
    this.storage = new CrossStorageClient( window.smeLocal.storageHub, {
      timeout: 5000,
      frameId: 'storageFrame'
    } );
    this.datenschutzPage = window.smeLocal.datenschutz || 'https://utopia.de/datenschutz/';
    this.datenschutzPage += '#SocialEmbeds';
    this.consentEvent = 'socialembed:consent';
    this.storageID = 'sme-consent';
    this.feed = this.element.data( 'feed' );
    this.config = this.element.data( 'config' ) || {id: ''};
    this.config.id = this.config.id ? this.config.id.trim() : '';
    this.previewtext = 'Mehr dazu in der  <a href="' + this.datenschutzPage + '" class="disclaimer-first" title="Informationen zum Datenschutz" target="_blank">Utopia Datenschutzerklärung.</a>';
    this.blockertext = 'Ja, ich möchte, dass Utopia mir Inhalte von **platform** anzeigt und kann das jederzeit widerrufen.';
    this.disclaimer = 'Dieses Element enthält Daten von **platform**. Du kannst die Einbettung auf unserer <a href="' + this.datenschutzPage + '" target="_blank"  class="disclaimer-first" title="Informationen zum Datenschutz">Datenschutzseite</a> deaktivieren.';
    this.removeListText = 'Aktive Verbindungen zu sozialen Netzwerken und anderen Internetdiensten:';
    this.services = services;
  }

  show() {
    if ( this.config.type === 'Glomex' ) {
      this.config.integrationId = '40599w1tl8yf6kos';
      this.displayEmbed();
      return;
    }
    if ( this.config.type === 'Opinary' ) {
      this.displayEmbed();
      return;
    }
    if ( this.config.type === 'Internal' ) {
      this.displayEmbed();
      return;
    }
    if ( this.config.type === 'Podigee' ) {
      this.displayEmbed();
      return;
    }

    this.haveConsent( this.config.type, ( isActivated ) => {
      if ( isActivated ) {
        this.displayEmbed();
      } else {
        this.displayOptIn();
      }
    } );
  }

  showRemoveList() {
    this.getStorageInfo( ( store ) => {
      const cont = $( '<div class="js-sme-remove"><ul></ul></div>' );
      let arr = store && store.length > 0 ? store.split( ',' ) : [];

      if ( this.element.find( '.js-sme-remove' ).length === 0 ) {
        cont.prepend( $( '<p><strong>' + this.removeListText + '</strong></p>' ) );
        this.element.on( 'click.ui-remove', '.js-sme-removeItem', ( e ) => {
          this.removeFromList( $( e.currentTarget ).data().id, arr );
        } );
        this.element.append( cont );
        this.noActiveConnections( arr );

      } else {
        this.noActiveConnections( arr );

      }
      if ( arr.length > 0 ) {
        this.element.find( '.js-sme-remove ul' ).html( '' );

        $( arr ).each( ( i ) => {
          if ( arr[i].length > 0 ) {
            const name = DETAIL_NAMES[arr[i]] ? DETAIL_NAMES[arr[i]] : arr[i];
            const screenname = this.services[arr[i]] ? this.services[arr[i]].screenname : name;
            let item = $( '<li data-id="' + arr[i] + '" class="js-sme-removeItem mb20"><span class="plattform">' + screenname + '</span><span class="btn">Entfernen</span></li>' );
            this.element.find( '.js-sme-remove ul' ).append( item );
          }
        } );
      }
    } );
  }

  displayOptIn() {
    const name = DETAIL_NAMES[this.config.type] ? DETAIL_NAMES[this.config.type] : this.services[this.config.type].screenname;
    const platformName = this.services[this.config.type].screenname;
    const sloganname = this.services[this.config.type].sloganname;
    let optinDiv = null;
    if ( CUSTOM_WIDGETS[platformName] ) {
      optinDiv = jQuery( CUSTOM_WIDGETS[platformName].replaceAll( "{{configId}}", this.config.id ) );
    } else {
      optinDiv = jQuery( `
<div class="js-sme-slogan slogan mt10">Hier ist eigentlich ein ${sloganname} zu sehen.</div>
<div class="js-sme-privacydisclaimer js-sme-blocked">
  <div class="js-sme-form-button fs16">
    <input class="checkbox js-sme-consent-button" type="checkbox" id="extcontent_${this.config.id}" value="${this.config.type}" name="input-form_${this.config.id}" />
    <label for="extcontent_${this.config.id}"><span class="fs16"><strong>
      ${this.platformReplace( this.blockertext, name )}
    </strong></span></label>
  </div>
  <span class="copy-txt fullwidth fs15">
    ${this.platformReplace( this.previewtext, name )}
  </span>
</div>
` );
    }
    this.element.addClass( 'contentblocked withicon mb20' );
    this.element.prepend( optinDiv );

    this.sendDataLayerEvent( 'consent' );

    $( '#extcontent_' + this.config.id ).on( 'click.ui-social', ( e ) => this.gettingConsent( $( e.currentTarget ) ) );
    $( 'body' ).on( this.consentEvent, ( evt, service ) => {
      if ( this.config.type === service ) {
        this.removeOptIn();
        this.displayEmbed();
      }
    } );
  }

  displayEmbed() {
    const name = DETAIL_NAMES[this.config.type] ? DETAIL_NAMES[this.config.type] : this.services[this.config.type].screenname;
    const disclaimer = '<span class="disclaimer fs14 mt10 mb20">' + this.platformReplace( this.disclaimer, name ) + '</span>';
    this.services[this.config.type].callback( this.element, this.feed, disclaimer, this.config );
    this.sendDataLayerEvent( 'embed' );
  }

  gettingConsent( current ) {
    if ( current.length > 0 ) {
      current.attr( 'checked', 'checked' );
      this.giveConsent( () => {
        current.trigger( this.consentEvent, [this.config.type] );
        this.sendDataLayerEvent( 'consent_given' );
      } );
    }
  }

  noActiveConnections( arr ) {
    if ( arr.length === 0 ) {
      this.element.find( '.js-sme-remove ul' ).remove();
      this.element.find( '.js-sme-remove' ).append( '<p>Keine</p>' );
    }
  }

  removeFromList( service, list ) {
    const isInList = $.inArray( service, list );
    if ( isInList !== -1 && list.splice( isInList, 1 ) ) {
      this.setStorageInfo( list.length > 0 ? list.join( ',' ) : '' );
      this.showRemoveList();
    }
  }

  giveConsent( cb ) {
    this.storage.onConnect().then( () => {
      return this.storage.get( this.storageID );
    } ).then( ( res ) => {
      let currentStorage = res;
      if ( currentStorage !== null && currentStorage !== '' ) {
        if ( currentStorage.indexOf( this.config.type ) === -1 ) {
          currentStorage += ',' + this.config.type;
          this.setStorageInfo( currentStorage );
        }
      } else {
        this.setStorageInfo( this.config.type );
      }
      setTimeout( () => {
        cb();
      }, 250 );
    } );

  }

  haveConsent( service, cb ) {
    this.storage.onConnect().then( () => {
      return this.storage.get( this.storageID );
    } ).then( ( res ) => {
      if ( res && res.indexOf( service ) !== -1 && service.length > 0 ) {
        return cb( true );
      }
      return cb( false );
    } );
  }

  getStorageInfo( cb ) {
    return this.storage.onConnect().then( () => {
      return this.storage.get( this.storageID );
    } ).then( ( res ) => {
      cb( res );
    } );
  }

  setStorageInfo( service ) {
    this.storage.onConnect().then( () => {
      return this.storage.set( this.storageID, service );
    } );
  }

  platformReplace( text, platform ) {
    return text.split( '**platform**' ).join( '' + platform );
  }

  removeOptIn() {
    this.element.find( '.js-sme-privacydisclaimer' ).remove();
    this.element.find( '.js-sme-slogan' ).remove();
    this.element.find( '.daa-widget-disclaimer' ).remove();
    this.element.removeClass( 'contentblocked withicon mb20' );
  }

  sendDataLayerEvent( eventType ) {

    const dataLayer = window.dataLayer || [];
    let evnt = {};
    if ( eventType === 'embed' || eventType === 'consent' ) {
      evnt = {
        event: 'SocialEmbed',
        platform: this.config.type,
        display_type: eventType,
        embed_id: this.config.id
      };
    } else if ( eventType === 'consent_given' ) {
      evnt = {
        event: 'SocialEmbedConsent',
        platform: this.config.type,
        embed_id: this.config.id
      };
    }
    dataLayer.push( evnt );
  }
}
